"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidatedAssociationRedirectUrl = exports.DEFAULT_ASSOCIATION_REDIRECT_ALLOWED_HOSTS = void 0;
// Todo: this should be moved to ENV variable in the future
// TD ticket: BAU-4681
exports.DEFAULT_ASSOCIATION_REDIRECT_ALLOWED_HOSTS = '*.test-aicpa.org,' +
    'rise-qa-app-btb8ded5eqbkajfh.eastus2-01.azurewebsites.net,' +
    'rise-prod-app-drefandnf6czcnas.eastus2-01.azurewebsites.net,' +
    'rise2040.com,' +
    'josi-qa-app-avc9grgpbsffadbt.eastus2-01.azurewebsites.net,' +
    'josi.aicpa-cima.com,' +
    'enterprise.aicpa-cima.com';
const normalizeAllowedHostPatterns = (allowedHosts) => allowedHosts
    .split(',')
    .map(pattern => pattern.trim().toLowerCase())
    .filter(Boolean);
const matchesAllowedHostPattern = (hostname, pattern) => {
    if (pattern.startsWith('*.')) {
        const suffix = pattern.slice(2);
        return Boolean(suffix) && hostname.endsWith(`.${suffix}`);
    }
    return hostname === pattern;
};
const getValidatedAssociationRedirectUrl = (value, allowedHosts = exports.DEFAULT_ASSOCIATION_REDIRECT_ALLOWED_HOSTS) => {
    if (!value)
        return undefined;
    try {
        const parsedUrl = new URL(value);
        const hostname = parsedUrl.hostname.trim().toLowerCase();
        const allowedHostPatterns = normalizeAllowedHostPatterns(allowedHosts);
        if (parsedUrl.protocol !== 'https:' ||
            !hostname ||
            parsedUrl.username ||
            parsedUrl.password ||
            !allowedHostPatterns.length ||
            !allowedHostPatterns.some(pattern => matchesAllowedHostPattern(hostname, pattern))) {
            return undefined;
        }
        return parsedUrl.toString();
    }
    catch (_a) {
        return undefined;
    }
};
exports.getValidatedAssociationRedirectUrl = getValidatedAssociationRedirectUrl;
//# sourceMappingURL=associationRedirect.js.map